export default __webpack_public_path__ + "static/media/circle2.f074c935.png";